export default "__VITE_ASSET__WFMP6L3Y__"